



























import { Component, Prop, Vue } from "vue-property-decorator";
import { ClientSetupMaster, ClientSetupOptions } from "@/data/models/ClientSetup";
import { EMPTY_VALUE } from "@/utils/ClientAdministrationDetail";
import { projectTypeText } from "@/utils/ClientProjectTypes";
import { ClientSetupDraft, followsMaster, possibleProjectTypeIds } from "@/utils/ClientSetupDraft";

@Component
export default class SetupProjectTypesStep extends Vue {
  @Prop({ required: true }) draft!: ClientSetupDraft;
  @Prop({ default: null }) options!: ClientSetupOptions | null;
  @Prop({ default: null }) master!: ClientSetupMaster | null;

  get member(): boolean {
    return followsMaster(this.draft);
  }

  get masterName(): string {
    return this.master?.name ?? EMPTY_VALUE;
  }

  get possible(): number[] {
    return possibleProjectTypeIds(this.options, this.draft.products);
  }

  get masterTypesText(): string {
    const ids = this.master?.projectTypeIds ?? [];
    return ids.length > 0 ? ids.map((id) => this.typeText(id)).join(", ") : EMPTY_VALUE;
  }

  typeText(id: number): string {
    return projectTypeText(id, (key) => this.$t(key).toString());
  }
}
